export default "/images/register-3.png?7f572c449e0ab5494f1053ccb7a83f0f";